module.exports = __webpack_public_path__ + "img/champion-betting-cn.d55ffbb8.gif";